import { apiClient } from './client'

export interface ApiKey {
  id: string
  name: string
  key_hint: string
  created_at: string
  last_used_at: string | null
  request_count: number
  is_revoked: boolean
}

export interface ApiKeyCreated extends ApiKey {
  full_key: string
}

class ApiKeysAPI {
  async create(orgId: string, name: string): Promise<ApiKeyCreated> {
    const response = await apiClient.post(`/organizations/${orgId}/api-keys`, { name })
    return response.data
  }

  async list(orgId: string): Promise<ApiKey[]> {
    const response = await apiClient.get(`/organizations/${orgId}/api-keys`)
    return response.data
  }

  async revoke(orgId: string, keyId: string): Promise<void> {
    await apiClient.delete(`/organizations/${orgId}/api-keys/${keyId}`)
  }
}

export const apiKeysAPI = new ApiKeysAPI()
